module.exports = __webpack_public_path__ + "static/harvard-soe-b7244a11d5842baac3a613b8cf3ab9c7.png";